import React from "react";
import { motion } from "framer-motion";
import logo from "../logo.png";
import "@fontsource/dancing-script/400.css";
import { Link } from "react-router-dom";

const Jumbotron = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="/video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="absolute top-0 left-0 w-full h-full bg-black/40"></div>

      {/* Foreground Content */}
      <div className="flex flex-col items-center justify-center h-full text-center text-white relative z-10 px-4">
        <motion.img
          src={logo}
          alt="Da Vittorio Logo"
          className="h-28 sm:h-32 md:h-36 mb-6 sm:mb-8"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        />
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="text-[24px] sm:text-[28px] md:text-[34px] lg:text-[38px] max-w-2xl font-dancing-script leading-relaxed"
        >
          Goditi un'esperienza unica in riva al mare con servizi esclusivi e momenti indimenticabili.
        </motion.p>
        <div className="mt-6 flex flex-col sm:flex-row gap-4 items-center">
        <Link to="/prenota">
  <motion.button
    whileHover={{ scale: 1.1 }}
    className="text-[22px] sm:text-[26px] md:text-[30px] px-8 sm:px-10 py-3 border-2 border-[#F4C623] text-[#F4C623] rounded-full hover:bg-yellow-500 hover:text-white transition duration-300 font-dancing-script"
  >
    Prenota ora
  </motion.button>
</Link>

<Link to="/contatti">
  <motion.button
    whileHover={{ scale: 1.1 }}
    className="text-[22px] sm:text-[26px] md:text-[30px] px-8 sm:px-10 py-3 border-2 border-[#009FB7] bg-[#009FB7] text-white rounded-full hover:bg-transparent hover:text-[#009FB7] transition duration-300 font-dancing-script"
  >
    Contattaci
  </motion.button>
</Link>

        </div>
      </div>
    </div>
  );
};

export default Jumbotron;
